<template>
<div>
    <md-toolbar class="mktops-toolbar">
        <div class="md-toolbar-row">
            <router-link class="mkt-link-icon" to="/">
                <img src="~@/assets/mktops_logo.png" alt="MKT OPS">
            <!-- <md-icon class="icon-brand">home</md-icon> -->
            </router-link>
            <router-link tag="h3" class="md-title" to="/">MKT OPS</router-link>
            <div class="md-toolbar-section-start">
                <router-link v-for="item in menu" :to="item.url" :key="item.id" v-on:click.native="selectHeadMenu(item.title)" class="menu-toolbar">{{item.title}}</router-link>
            </div>
            <div class="md-toolbar-section-end">
                <md-list class="profile-container">
                    <md-list-item class="profile">
                        <md-avatar>
                            <img src="https://placeimg.com/40/40/people/1" alt="People">
                        </md-avatar>
                        <div class="md-list-text-container">
                            <span class="body-primary-text defaultCls">{{user.firstname}}</span>
                            <span class="md-caption -list-block defaultCls ">{{user.lastname}}</span>
                        </div>
                    </md-list-item>
                </md-list>
                <md-menu md-size="medium" md-align-trigger>
                    <md-button class="md-icon-button" md-menu-trigger>
                        <md-icon>keyboard_arrow_down</md-icon>
                    </md-button>
                    <md-menu-content>
                        <md-menu-item @click="setting">SETTINGS</md-menu-item>
                        <md-menu-item @click="logout">LOGOUT</md-menu-item>
                    </md-menu-content>
                </md-menu>
            </div>
        </div>
    </md-toolbar>
    <md-toolbar class="head-mktops">
        <router-link v-for="item in submenu" :key="item.id" :to="item.url" class="nav-link">
            <span>{{item.title}}</span>
            <div class="border-link"></div>
        </router-link>
    </md-toolbar>
</div>
</template>
<script>

export default {
    created() {
        //this.$store.dispatch('menu/checkMenuLink');

    },
    computed: {
        menu(){
            return this.$store.getters['menu/menu'];
        },
        // headmenu() {
        //     return this.$store.getters['menu/headmenu']
        // },
        submenu() {
            return this.$store.getters['menu/submenu']
        },
        user(){
            return this.$jwt.decode(localStorage.getItem('token'));

            // return decodeURIComponent(atob(localStorage.getItem('token')).split('').map((c: any) => {
            //     return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            // }).join(''))

            
            //return JSON.parse(atob(localStorage.getItem('token').decode('UTF-8').split('.')[1]));
            //return this.$jwtDec(localStorage.getItem('token'));
            //return this.$store.getters['auth/user']
        }
    },
    methods: {
        logout() {
            //this.$store.dispatch('authen/logout')
            this.$store.dispatch('auth/logout').then(() => {
                //alert('logout');
                this.$router.push('/login')
            });

        },
        setting () {
          //this.$store.dispatch('menu/setSettMenu')
        },
        selectHeadMenu(menu) {
            this.$store.dispatch( 'menu/selectMenu', menu );
        }
    },
}
</script>